export default{
  userInfo:state=>state.userInfo,
  logined:state=>state.logined,
  title:state=>state.title,
  noticeData:state=>state.noticeData
}
